import React from 'react';
import {TrailRating, TrailRatingData} from "types/TrailRating";
import {Form, Formik, FormikHelpers} from "formik";
import Field from "components/Form/Field";
import FormControls from "components/FormControls";
import FieldHeader from "components/Form/FieldHeader";
import * as Yup from "yup";
import {ErrorNotification} from "../../../components/Form/ErrorNotification";
import {TextAreaField} from "../../../components/Form/Form";

// Types ----

type TrailRatingFormProps = {
  trailRating?: TrailRating | null
  onSubmit: (values: TrailRatingData, helpers: FormikHelpers<TrailRatingData>) => any
}

// Component ----

function TrailRatingForm({onSubmit, trailRating}: TrailRatingFormProps) {
  const validationSchema = Yup.object().shape({
    name: Yup.string().required("This field is required").max(250, "Maximum character limit exceeded"),
    description: Yup.string().max(250, "Maximum character limit exceeded"),
  })

  const initialValues: TrailRatingData = {
    name: trailRating?.name || '',
    description: trailRating?.description || '',
    colour: trailRating?.colour || '#3e3e3e',
  }

  return (
    <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
      {formik => (
        <Form className="space-y-8 divide-y divide-gray-200">
          <ErrorNotification formik={formik} />

          <div className="shadow sm:rounded-md">
            <div className="px-4 py-5 bg-white sm:p-6 sm:rounded-md">
              <div className="space-y-8 divide-y divide-gray-200">
                <div>
                  <div>
                    <h3 className="text-lg leading-6 font-medium text-gray-900">
                      Key Information
                    </h3>
                    <p className="mt-1 text-sm text-gray-500">
                      Basic details about the trail rating
                    </p>
                  </div>
                  <div className="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">

                    {/* Name */}
                    <div className="sm:col-span-3">
                      <div className="mt-1">
                        <Field
                          label="Name *"
                          hint='250 chars max'
                          type="text"
                          name="name"
                          id="name"
                          autoComplete="off"
                          maxLength="250"
                          autoFocus
                        />
                      </div>
                    </div>

                    {/* Description */}
                    <div className="sm:col-span-5">
                      <div className="mt-1">
                        <TextAreaField
                          name="description"
                          id="description"
                          label="Description"
                          hint="Optional. 250 chars max."
                          autoComplete="off"
                          maxChars={250}
                          rows={3}
                        />
                      </div>
                    </div>

                    {/* Colour */}
                    <div className="sm:col-span-1 sm:col-start-1">
                      <FieldHeader label="Colour *"/>
                      <Field
                        className="appearance-none w-full h-14 -ml-0.5 bg-transparent border-0 cursor-pointer"
                        type="color"
                        name="colour"
                        id="colour"
                      />
                    </div>

                  </div>
                </div>

              </div>
            </div>

            <FormControls formik={formik}/>
          </div>
        </Form>
      )}
    </Formik>
  );
}

export default TrailRatingForm;